import { render, staticRenderFns } from "./participants-diff-popover.vue?vue&type=template&id=24c2debe&scoped=true"
import script from "./participants-diff-popover.vue?vue&type=script&lang=js"
export * from "./participants-diff-popover.vue?vue&type=script&lang=js"
import style0 from "./participants-diff-popover.vue?vue&type=style&index=0&id=24c2debe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c2debe",
  null
  
)

export default component.exports